module.exports = __webpack_public_path__ + "img/stock7.4633743d.png";